import moment, { type MomentInput } from 'moment'

import { MOMENT_FORMATS } from '@/localize'

type FormatDatePattern = 'ymdw' | 'ymd' | 'md' | 'mdy' | 'mdyhm' | 'MMMMD' | 'MMMDYYYY' | 'MMMMDYYYY'

export function formatDate (date?: MomentInput, format?: FormatDatePattern | string): string {
  const FORMAT_DATE_PATTERNS: Record<string, string> = {
    ymdw: MOMENT_FORMATS.ddd_MMM_D_YYYY,
    ymd: MOMENT_FORMATS.MMM_D_YYYY,
    md: MOMENT_FORMATS.MMM_D,
    mdy: MOMENT_FORMATS.MM_DD_YYYY,
    mdyhm: `${MOMENT_FORMATS.MM_DD_YYYY} • ${MOMENT_FORMATS.hm_A}`,
    MMMMD: MOMENT_FORMATS.MMMM_D,
    MMMDYYYY: MOMENT_FORMATS.MMM_D_YYYY,
    MMMMDYYYY: MOMENT_FORMATS.MMMM_D_YYYY,
  }

  const momentFormat = (format && FORMAT_DATE_PATTERNS[format])
    || format
    || MOMENT_FORMATS.MMM_D_YYYY

  return date
    ? moment(date).format(momentFormat)
    : moment().format(momentFormat)
}

export function formatDateNice (date: MomentInput): string {
  return moment(date).calendar(null, MOMENT_FORMATS.calendar)
}
